import { formatPhoneNumber } from "../../../utils/FormatPhoneNumber";
import decamelizeKeysDeep from "decamelize-keys-deep";

export type UpdateProfileFormData = {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  mailAddress?: {
    address?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string;
    countryId?: string;
  } | null;
  homeAddress?: {
    address?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string;
    countryId?: string;
  } | null;
  licenseNumber?: string;
  companyName?: string;
  sameMailAndPhysicalAddress?: boolean;
};

/**
 * Build payload to update contact from the citizens API
 * @param data
 */
export function buildUpdateProfilePayload(data: UpdateProfileFormData) {
  const updateContactPayload = {
    firstName: data?.firstName,
    lastName: data?.lastName,
    email: data?.email,
    phone: data.phone ? formatPhoneNumber(data.phone) : undefined,
    address: data.mailAddress?.address,
    address2: data.mailAddress?.address2,
    city: data.mailAddress?.city,
    state: data.mailAddress?.state,
    zip: data.mailAddress?.zip,
    countryId: data.mailAddress?.countryId,
    ...(!data.sameMailAndPhysicalAddress
      ? {
          homeAddress: data.homeAddress?.address,
          homeAddress2: data.homeAddress?.address2,
          homeCity: data.homeAddress?.city,
          homeState: data.homeAddress?.state,
          homeZip: data.homeAddress?.zip,
          homeCountryId: data.homeAddress?.countryId,
        }
      : {}),
    sameMailAndPhysicalAddress: data.sameMailAndPhysicalAddress,
    licenseNumber: data?.licenseNumber,
    companyName: data?.companyName,
  };

  // Return payload with undefined/null values removed
  const payloadNullsRemoved = Object.entries(updateContactPayload).reduce(
    (payload, [key, val]) => {
      if (val != null) {
        payload[key] = val;
      }
      return payload;
    },
    {} as { [key: string]: any },
  );

  return decamelizeKeysDeep(payloadNullsRemoved, "_"); // The identity service expects snake_case keys
}
